import { render } from "./TableOfContents.vue?vue&type=template&id=2d71a8d7&ts=true"
import script from "./TableOfContents.vue?vue&type=script&lang=ts"
export * from "./TableOfContents.vue?vue&type=script&lang=ts"

import "./TableOfContents.vue?vue&type=style&index=0&id=2d71a8d7&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__